import { Button, Collapse, Form, Input, InputNumber } from 'antd';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash'
const { Panel } = Collapse;

export default props => {
    const { form } = props;
    return (
        <>
            <div className="description">
                Highlight your top 5 skills that align with the job requirements. Pro tip: Incorporate key terms from the job description to enhance your resume's relevance.
            </div>
            <Form.List name="skills">
                {(fields, { add, remove }) => {

                    return (
                        <>
                            {fields.map(({ key, name, ...restField }) => {
                                const skillName = form.getFieldValue(['skills', name, 'name']) || `Skill ${name + 1}`;
                                return (
                                    <Collapse className="skills-collapse">
                                        <Panel key={`skill-${key}`} align="baseline" className="skill-item" header={(<div className="skill-item-header">
                                            <div className="left">
                                                {skillName}
                                            </div>
                                            <div className="right" >
                                                <FaTrash onClick={() => remove(name)} style={{ cursor: 'pointer' }} />
                                            </div>
                                        </div>)}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'name']}  // Adjusted to handle string values directly
                                                label="Skill name"
                                                rules={[{ required: true, message: 'Please enter a skill name' }]}
                                            >
                                                <Input placeholder="Enter skill name" />
                                            </Form.Item>

                                            <Form.Item
                                                {...restField}
                                                name={[name, 'level']}  // Adjusted to handle string values directly
                                                label="Skill level (1-10)"
                                                rules={[{ required: true, message: 'Please enter a skill level' }]}
                                            >
                                                <InputNumber placeholder="Enter skill level" />
                                            </Form.Item>
                                        </Panel>
                                    </Collapse>
                                )
                            })}
                            <Button type="dashed" onClick={() => add()} block>
                                Add Skill
                            </Button>
                        </>
                    )
                }}

            </Form.List>
        </>
    )
}